import gql from "graphql-tag";

export const SSO_LOGIN = gql`
  query ssoLogin($username: String!, $password: String!) {
    ssoLogin(username: $username, password: $password) {
      accessToken
      sessionPeriod
      accessTokenPeriod
      contractCode
      currentUser {
        _id
        email
        phone
        ldapUser
        employee
        lastPasswordChange
        validFrom
        validTo
      }
      isTemporaryPassword
    }
  }
`;
